import React from 'react';
import { Card } from '../components/ui/card';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-[#050505] text-white pt-32 pb-20 px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Terms of Service</h1>
        <p className="text-[#C7CCD8] mb-8">Last updated: December 13, 2025</p>

        <Card className="p-8 bg-white/5 border-[#1B2FFF]/20 mb-6">
          <div className="prose prose-invert max-w-none">
            <h2 className="text-2xl font-bold text-white mb-4">1. Acceptance of Terms</h2>
            <p className="text-[#C7CCD8] mb-6 leading-relaxed">
              By accessing or using Liquicent's services, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using our services.
            </p>

            <h2 className="text-2xl font-bold text-white mb-4 mt-8">2. Use License</h2>
            <p className="text-[#C7CCD8] mb-4 leading-relaxed">
              Subject to these terms, Liquicent grants you a limited, non-exclusive, non-transferable license to:
            </p>
            <ul className="list-disc list-inside text-[#C7CCD8] space-y-2 mb-6">
              <li>Access and use our platform for your internal business purposes</li>
              <li>Deploy and manage autonomous agents within your enterprise</li>
              <li>Access our API and documentation</li>
            </ul>

            <h2 className="text-2xl font-bold text-white mb-4 mt-8">3. Restrictions</h2>
            <p className="text-[#C7CCD8] mb-4 leading-relaxed">You may not:</p>
            <ul className="list-disc list-inside text-[#C7CCD8] space-y-2 mb-6">
              <li>Reverse engineer, decompile, or disassemble our software</li>
              <li>Remove any copyright or proprietary notices</li>
              <li>Transfer or sublicense your account to third parties</li>
              <li>Use our services for illegal purposes</li>
              <li>Attempt to gain unauthorized access to our systems</li>
            </ul>

            <h2 className="text-2xl font-bold text-white mb-4 mt-8">4. Account Responsibilities</h2>
            <p className="text-[#C7CCD8] mb-4 leading-relaxed">You are responsible for:</p>
            <ul className="list-disc list-inside text-[#C7CCD8] space-y-2 mb-6">
              <li>Maintaining the confidentiality of your account credentials</li>
              <li>All activities that occur under your account</li>
              <li>Notifying us immediately of any unauthorized access</li>
              <li>Ensuring compliance with applicable laws and regulations</li>
            </ul>

            <h2 className="text-2xl font-bold text-white mb-4 mt-8">5. Payment Terms</h2>
            <p className="text-[#C7CCD8] mb-4 leading-relaxed">
              All fees are due as specified in your subscription agreement. We reserve the right to:
            </p>
            <ul className="list-disc list-inside text-[#C7CCD8] space-y-2 mb-6">
              <li>Suspend access for non-payment</li>
              <li>Change pricing with 30 days notice</li>
              <li>Charge for overages as specified in your plan</li>
            </ul>

            <h2 className="text-2xl font-bold text-white mb-4 mt-8">6. Service Level Agreement</h2>
            <p className="text-[#C7CCD8] mb-6 leading-relaxed">
              Liquicent commits to 99.9% uptime for production services. Detailed SLA terms are provided in your enterprise agreement.
            </p>

            <h2 className="text-2xl font-bold text-white mb-4 mt-8">7. Data Ownership</h2>
            <p className="text-[#C7CCD8] mb-6 leading-relaxed">
              You retain all rights to your data. Liquicent claims no ownership over any data, files, or content you upload or create using our platform. We process your data solely to provide our services.
            </p>

            <h2 className="text-2xl font-bold text-white mb-4 mt-8">8. Intellectual Property</h2>
            <p className="text-[#C7CCD8] mb-6 leading-relaxed">
              The Liquicent platform, including all software, documentation, and materials, is protected by copyright, trademark, and other intellectual property laws. All rights not expressly granted are reserved.
            </p>

            <h2 className="text-2xl font-bold text-white mb-4 mt-8">9. Warranties and Disclaimers</h2>
            <p className="text-[#C7CCD8] mb-4 leading-relaxed">
              Our services are provided "as is" without warranties of any kind. We do not warrant that:
            </p>
            <ul className="list-disc list-inside text-[#C7CCD8] space-y-2 mb-6">
              <li>Services will be uninterrupted or error-free</li>
              <li>Defects will be corrected immediately</li>
              <li>Results will meet your specific requirements</li>
            </ul>

            <h2 className="text-2xl font-bold text-white mb-4 mt-8">10. Limitation of Liability</h2>
            <p className="text-[#C7CCD8] mb-6 leading-relaxed">
              Liquicent shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of our services. Our total liability shall not exceed the fees paid by you in the 12 months preceding the claim.
            </p>

            <h2 className="text-2xl font-bold text-white mb-4 mt-8">11. Indemnification</h2>
            <p className="text-[#C7CCD8] mb-6 leading-relaxed">
              You agree to indemnify Liquicent against any claims arising from your use of our services, violation of these terms, or infringement of any third-party rights.
            </p>

            <h2 className="text-2xl font-bold text-white mb-4 mt-8">12. Termination</h2>
            <p className="text-[#C7CCD8] mb-6 leading-relaxed">
              Either party may terminate this agreement with 30 days written notice. Liquicent may terminate immediately for breach of terms. Upon termination, you must cease all use of our services and we will provide data export for 30 days.
            </p>

            <h2 className="text-2xl font-bold text-white mb-4 mt-8">13. Governing Law</h2>
            <p className="text-[#C7CCD8] mb-6 leading-relaxed">
              These terms are governed by the laws of Delaware, United States, without regard to conflict of law principles. Any disputes shall be resolved through binding arbitration.
            </p>

            <h2 className="text-2xl font-bold text-white mb-4 mt-8">14. Changes to Terms</h2>
            <p className="text-[#C7CCD8] mb-6 leading-relaxed">
              We may modify these terms at any time. Material changes will be notified via email. Continued use of our services after changes constitutes acceptance.
            </p>

            <h2 className="text-2xl font-bold text-white mb-4 mt-8">15. Contact Information</h2>
            <p className="text-[#C7CCD8] leading-relaxed">
              For questions about these terms, contact us at:
              <br />
              <a href="mailto:legal@liquicent.com" className="text-[#1B2FFF] hover:text-[#B8C6FF] transition-colors">
                legal@liquicent.com
              </a>
            </p>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default TermsOfService;